const _debounce = require('lodash.debounce');
const _throttle = require('lodash.throttle');

window.addEventListener('load', () => {
    const scrollFaders = document.querySelectorAll('.scroll-fader');
    if (scrollFaders.length) {
        let frameRateTarget = 24;  // Initially set for 30fps
        let disableEffect = false;
        let throttledUpdateScrollFaders;

        const updateThrottleRate = () => {
            throttledUpdateScrollFaders = _throttle(updateScrollFaders, frameRateTarget);
        };

        const updateFrameRateTarget = _debounce(function() {
            if (window.matchMedia('(max-width: 767px)').matches) {
                frameRateTarget = 24; // Throttle to 30fps on mobile/tablet
                disableEffect = false;
            } else if (window.matchMedia('(min-width:768px) and (max-width: 1023px)').matches) {
                frameRateTarget = 24; // Throttle to 30fps on mobile/tablet
                disableEffect = false;
            } else {
                frameRateTarget = 12; // Throttle to 60fps on desktop
                disableEffect = false;
            }
            updateThrottleRate(); // Update the throttle rate whenever frameRateTarget changes
            updateScrollFaders(); // Update faders after changing settings
        }, 200);

        const updateScrollFaders = () => {
            scrollFaders.forEach(scrollFader => {
                let startEffectPos = scrollFader.getBoundingClientRect().top + window.scrollY;
                let endEffectPos = startEffectPos + scrollFader.offsetHeight;
                updateScrollEffect(scrollFader, startEffectPos, endEffectPos);
            });
        };

        const updateScrollEffect = (scrollFader, start, end) => {
            // Check if the element or any parent has a .fixed class
            const fixedElement = scrollFader.closest('.fixed');
            let parallaxEffect = true;

            if (fixedElement) {
                const style = window.getComputedStyle(fixedElement);
                const topStyle = style.top;
                const topValue = topStyle === 'auto' ? 0 : parseInt(topStyle, 10);
                start = topValue;
                end = start + fixedElement.offsetHeight; // end based on the height of the fixed element
                parallaxEffect = false;
            }
            if (disableEffect) {
                scrollFader.style.transform = 'translateY(0)';
                scrollFader.style.filter = 'blur(0)';
                scrollFader.style.opacity = 1;
            } else {
                const scrollPosition = window.scrollY;
                if (scrollPosition >= start && scrollPosition <= end) {
                    const percentage = (scrollPosition - start) / (end - start);
                    const parallaxValue = (scrollPosition - start) * 0.3 + 'px';
                    const blurValue = 20 * percentage + 'px';
                    const opacityValue = 1 - percentage;
                    if (parallaxEffect) {
                        scrollFader.style.transform = `translateY(${parallaxValue})`;
                        scrollFader.style.opacity = opacityValue;
                    }
                    scrollFader.style.filter = `blur(${blurValue})`;
                } else if (scrollPosition < start) {
                    scrollFader.style.transform = 'translateY(0)';
                    scrollFader.style.filter = 'blur(0)';
                    scrollFader.style.opacity = 1;
                } else if (scrollPosition > end) {
                    if (parallaxEffect) {
                        scrollFader.style.transform = `translateY(${(end - start) * 0.3}px)`;
                        scrollFader.style.opacity = 0;
                    }
                    scrollFader.style.filter = 'blur(20px)';
                }
            }
        };

        // Initialize throttle function and event listeners
        updateThrottleRate();
        window.addEventListener('resize', () => {
            updateFrameRateTarget();
        });

        window.addEventListener('scroll', throttledUpdateScrollFaders);

        // Initial setup
        updateFrameRateTarget();
        updateScrollFaders();
    }
});
